// Brief loading state while confirming Stripe payment after redirect.

import React from 'react';
import logoSrc from '../../assets/mywellfie-header-logo.png';
import './landing.css';

const AdhocPaymentConfirmStage: React.FC = () => (
  <div className="adhoc-landing" style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
    <nav>
      <div className="wrap">
        <div className="nav-logo">
          <img src={logoSrc} alt="MyWellfie" />
        </div>
      </div>
    </nav>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20,
        padding: 48,
      }}
    >
      <div className="pay-overlay-spinner" />
      <p style={{ color: 'var(--muted)', fontWeight: 600, fontSize: 16 }}>
        Confirming your payment…
      </p>
    </div>
  </div>
);

export default AdhocPaymentConfirmStage;
